import React from 'react';
import { MagnifyingGlassIcon, MapPinIcon } from '@heroicons/react/24/outline';

const BusinessSearch = ({ searchTerm, setSearchTerm }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <div className="relative">
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search for businesses, services, or locations..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>
      
      <div className="flex items-center mt-3 text-sm text-gray-500">
        <MapPinIcon className="h-4 w-4 mr-1" />
        <span>Popular: Haircut, Massage, Gym, Doctor, Ride</span>
      </div>
    </div>
  );
};

export default BusinessSearch;